export const lgScreen = '1699px'
export const desktopMdScreen = '1549px'
export const desktopScreen = '1319px'
export const desktopSmScreen = '1180px'
export const tabletScreen = '1023px'
export const phoneScreen = '767px'
export const smallPhoneScreen = '375px';
